/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Featured Collection: show 8 random products from the entire catalog on each page load.
 * - Standard Warehouse sections: shuffle the already-rendered products in place.
 * - Custom Shop4fish home (.s4f-products): fetch the full catalog via /products.json,
 *   pick 8 at random, and render them.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Standard Warehouse featured-collection sections: shuffle in place
  document.querySelectorAll('[data-section-type="featured-collection"]').forEach(function(section) {
    var list = section.querySelector('.product-list');
    if (!list) return;
    var items;
    if (list.querySelector(':scope > .product-list__column')) {
      items = Array.from(list.querySelectorAll(':scope > .product-list__column'));
    } else {
      items = Array.from(list.children);
    }
    shuffleArray(items);
    items.forEach(function(item) { list.appendChild(item); });
  });

  // Custom Shop4fish home: load 8 random products from the full catalog
  var s4fContainer = document.querySelector('.s4f-products');
  if (s4fContainer) {
    loadRandomProducts(s4fContainer, 8);
  }

  function shuffleArray(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }
    return arr;
  }

  function loadRandomProducts(container, count) {
    var all = [];
    var page = 1;

    function fetchPage() {
      fetch('/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data && data.products && data.products.length) {
            all = all.concat(data.products);
          }
          if (data && data.products && data.products.length === 250) {
            page++;
            fetchPage();
          } else {
            renderRandom(container, all, count);
          }
        })
        .catch(function() {
          // On failure, leave the server-rendered products as-is.
        });
    }

    fetchPage();
  }

  function escapeAttribute(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderRandom(container, products, count) {
    if (!products.length) return;
    var picked = shuffleArray(products.slice()).slice(0, count);
    var html = '';
    picked.forEach(function(p) {
      var url = '/products/' + p.handle;
      var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
      var title = p.title || '';
      var rawPrice = (p.variants && p.variants[0] && p.variants[0].price) ? p.variants[0].price : '';
      var price = rawPrice !== '' ? '$' + parseFloat(rawPrice).toFixed(2) : '';
      var escTitle = title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function(tag) { return tag.trim(); });
      var freeShipping = tags.indexOf('free-shipping-plants') !== -1 || tags.indexOf('free-shipping-media') !== -1;
      var badgeLabel = escapeAttribute(container.dataset.freeShippingLabel || '');
      var badgeDetails = escapeAttribute(container.dataset.freeShippingDetails || '');
      var badge = freeShipping && badgeLabel ? '<span class="s4f-free-shipping-badge" title="' + badgeDetails + '">' + badgeLabel + '</span>' : '';
      html += '<a class="s4f-product" href="' + url + '">'
        + '<div class="s4f-product-image">' + (img ? '<img src="' + img + '" alt="' + escTitle + '" loading="lazy">' : '') + '</div>'
        + '<div class="s4f-product-title">' + escTitle + '</div>'
        + '<div class="s4f-stars">★★★★★</div>'
        + '<div class="s4f-price">' + price + '</div>' + badge
        + '</a>';
    });
    container.innerHTML = html;
  }
});

